import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import {
  MODAL_TYPES,
  ORDER_STATUS_TYPES,
  VIDEO_TYPES,
} from '@/constants/constants.js';
import LoadingIndicator from '@/components/LoadingIndicator.js';
import ImageFixModal from '../../../components/ImageFixModal/ImageFixModal.js';

const FlowButtons = ({
  setModalType,
  setConfirmText,
  setModalVisible,
  selectedOrder,
  isDownloadLoading,
  fetchData,
}) => {
  // 新增弹窗相关状态
  const [showFixFailModal, setShowFixFailModal] = useState(false);

  // 订单资料下载按钮逻辑
  const handleDownload = async () => {
    // 先获取最新数据
    if (fetchData) {
      await fetchData();
    }

    if (!selectedOrder || !selectedOrder.images) {
      alert('未获取到图片信息');
      return;
    }
    setShowFixFailModal(true);
  };

  const [completeBtnVisible, setCompleteBtnVisible] = useState(false);
  const [flowBtnVisible, setFlowBtnVisible] = useState(false);

  useEffect(() => {
    if (selectedOrder) {
      const orderStatus = selectedOrder.status;

      setFlowBtnVisible(
        selectedOrder.videoType !== VIDEO_TYPES.数字音容版 &&
          selectedOrder.videoType !== VIDEO_TYPES.数字音容Plus &&
          (orderStatus === ORDER_STATUS_TYPES.工作流待开始 ||
            orderStatus === ORDER_STATUS_TYPES.工作流进行中 ||
            orderStatus === ORDER_STATUS_TYPES.工作流失败 ||
            orderStatus === ORDER_STATUS_TYPES.工作流已完成)
      );

      setCompleteBtnVisible(
        orderStatus !== ORDER_STATUS_TYPES.未提交 &&
          orderStatus !== ORDER_STATUS_TYPES.文案确认中 &&
          orderStatus !== ORDER_STATUS_TYPES.审核中 &&
          orderStatus !== ORDER_STATUS_TYPES.已完成 &&
          orderStatus !== ORDER_STATUS_TYPES.资料修改中
      );
    }
  }, [selectedOrder]);

  return (
    <>
      <div className="flow-btns-container">
        {flowBtnVisible && (
          <div className="flow-start-container">
            <Button
              onClick={() => {
                setModalType(MODAL_TYPES.请选择自动化流程);
                setConfirmText('确认开启工作流');
                setModalVisible(true);
              }}
            >
              工作流开启
            </Button>
          </div>
        )}
        {completeBtnVisible && (
          <div className="flow-start-container">
            <Button
              onClick={() => {
                setModalType(MODAL_TYPES.确认完结订单);
                setConfirmText('确认完结');
                setModalVisible(true);
              }}
            >
              完结订单
            </Button>
          </div>
        )}

        {isDownloadLoading ? (
          <LoadingIndicator
            label={'资料正在下载，请等待'}
            containerClassName={'flex-row'}
            border={true}
          />
        ) : (
          <Button variant="primary" onClick={handleDownload}>
            订单资料下载
          </Button>
        )}
      </div>
      <ImageFixModal
        show={showFixFailModal}
        images={selectedOrder?.images || []}
        clientInfo={selectedOrder}
        client_id={selectedOrder?.client_id}
        onClose={() => setShowFixFailModal(false)}
      />
    </>
  );
};

export default FlowButtons;
